// extracted by mini-css-extract-plugin
export default {"container":"CoursesSection_container__u2qBz","body":"CoursesSection_body__kwsL0","text":"CoursesSection_text__Iue1E"};